import React from "react";

const Paragraph = (props) => {
  if (typeof props.children[0].type === "function") {
    return <>{props.children}</>;
  }
  return <p>{props.children}</p>;
};

export default Paragraph;
